import {
  createRouter,
  createWebHistory,
  Router,
  RouteRecordRaw,
} from "vue-router";
import { RouteNames, RoutePaths } from "@/router/routes";

export const routes: RouteRecordRaw[] = [
  {
    path: RoutePaths.MainLayout,
    name: RouteNames.MAIN_LAYOUT,
    component: () => import("@/layouts/MainLayout.vue"),
    children: [
      {
        path: "",
        redirect: {
          name: RouteNames.SUPPORT_MAIN_PAGE,
          query: { service: "all" },
        },
      },
      {
        path: RoutePaths.SupportMainPage,
        name: RouteNames.SUPPORT_MAIN_PAGE,
        component: () => import("@/views/SupportMainPage.vue"),
        children: [
          {
            path: RoutePaths.SupportTicket,
            name: RouteNames.CURRENT_TICKET,
            component: () => import("@/views/SupportMainPage.vue"),
          },
        ],
      },
      {
        path: RoutePaths.SupportAnalyticsPage,
        name: RouteNames.ANALYTICS,
        component: () => import("@/views/SupportAnalyticsPage.vue"),
      },
      {
        path: RoutePaths.SupportAccessesPage,
        name: RouteNames.ACCESSES,
        component: () => import("@/views/SupportAccessesPage.vue"),
      },
      {
        path: RoutePaths.SupportThemesPage,
        name: RouteNames.THEME,
        component: () => import("@/views/SupportThemesPage.vue"),
      },
    ],
  },
  {
    path: RoutePaths.NotFound,
    name: RouteNames.NOT_FOUND,
    component: () => import("@/views/NotFoundPage.vue"),
  },
];

const router: Router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: routes,
});

router.beforeEach((to) => {
  // const mainStore = useMainStore(); //pinia указывается тут

  // if (!mainStore.isAuthorized && to.name !== "Authorization") {
  //   return { name: "Authorization" };
  // }

  // @ts-ignore
  document.title = to.meta.title ?? window.document.title;
});

export default router;
